import GenerateRecipesQuery from '../models/helpers/generateRecipesQuery.ts';
import { Recipe } from '../models/recipes/recipe.ts';
import { RecipeSearchParam } from '../models/searchParams/recipeSearchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";

const RecipesController = {
    get: (tableSearchParam: TableSearchParam, searchParam: RecipeSearchParam) => {
        let url = `recipes/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateRecipesQuery(searchParam)}`;
        return ApiClient.get(url);
    },
    getByID: (id: number) => {
        return ApiClient.get(`recipe/${id}`);
    },
    post: (recipe: Recipe) => {
        return ApiClient.post('recipe', recipe);
    },
    put: (recipe: Recipe) => {
        return ApiClient.put(`recipe/${recipe.recipeID}`, recipe);
    },
    delete: (id: number) => {
        return ApiClient.delete(`recipe/${id}`)
    }
};
export default RecipesController;